/* global grecaptcha, hcaptcha, turnstile */
import captchaTpl from '../views/captcha.html';
import { getRndHash } from '../utils';

let instance;

const
    recaptchaTpl = (id) => `<div class="captcha" id="${id}" style="display:none"></div>`,
    defaults     = (cid => ({
        autoFocus: true,
        btnName: '.captcha__regenerate',
        checkCaptchaPath: 'captcha/check',
        cid: ['#captcha_', cid].join(''),
        elmName: '.captcha',
        id: cid,
        imgName: '.captcha__img',
        imgPath: '/captcha',
        inputClass: '.captcha__input',
        inputID: ['#captcha-input', '_', cid].join(''),
        inputName: 'userpin',
        /* NOTE:
         * Max length must be fixed here.
         * When one regenerates capcha, it can contain 5, 6 or 7 characters.
         * https://jira.dev.inbox.lv/browse/LOGIN-2426
        */
        maxLength: 10,
        minLength: 5,
        nameSpace: '',
        rcContainerID: '#recaptchaContent',
        rcResponseID: '#g-recaptcha-response',
        showHint: true,
        useRecaptcha: false,
        userInputID: '#userName'
    }))(getRndHash(10));

// NOTE: In modal dialog it works only attached on an element that is outside of jQuery dialog control!
function eventHandlers(opts, captcha) {
    const {
        cid,
        btnName,
        imgName,
        inModal,
        inputID
    } = opts;
    let handlersAttached = false;

    return () => {
        if (handlersAttached) {
            return;
        }
        // "Regenerate" listener
        $('body').on('click.captchaRegenerate2', cid, (e) => {
            const targetElm = [btnName, imgName].join(','),
                isTarget = $(e.target).closest(targetElm).length;

            if (isTarget) {
                captcha.regenerate(true);
            }
        });
        // No need to check captcha on 'enter' key when not in modal
        if (inModal) {
            // "Enter" key listener
            $('body').on('keydown', inputID, (e) => {
                if (e.keyCode === 13) {
                    captcha.check();
                }
            });
        }
        handlersAttached = true;
    };
}

function checkPinLength(captcha) {
    const
        {
            $dialog,
            i18n: { captchaErrorText },
            inputID
        } = captcha.param.get(),
        captchaAlert = $dialog.flash(); // XXX: Method 'flash' has not only modal

    return new Promise((resolve, reject) => {
        const
            $userPin   = $(inputID),
            userPinVal = $userPin.val().trim();

        // Captcha symbol length can vary. So check it has more than 1 character
        if (userPinVal.length > 1) {
            captchaAlert.close();
            resolve(userPinVal);
        }
        else {
            captchaAlert.show('danger', captchaErrorText);
            captcha.setFocus();
        }
    });
}

function inIframe() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}

function postToServer(path, params) {
    return $.post(path, params).promise();
}

function getResponse(captcha, userPin) {
    const {
            $dialog,
            checkCaptchaPath,
            cid,
            grecaptchaSiteKey,
            i18n,
            inputID,
            nameSpace,
            rcContainerID: rcWrapId,
            type,
            userInputID
        } = captcha.param.get(),
        alertFn    = $dialog.flash(),
        $userPin   = $(inputID),
        postParams = { 'userpin': userPin, 'namespace': nameSpace, 'iframe': inIframe(), 'imapuser': $(userInputID).val()};

    function showErr() {
        $userPin.parent().addClass('has-error');
        captcha.regenerate(true);
        alertFn.show('danger', i18n.captchaErrorText);
    }

    return new Promise((resolve, reject) => {
        // console.info('pin: %s', pin);
        postToServer(checkCaptchaPath, postParams)
            .then(response => {
                const { captchaCorrect, showRecaptcha} = response;

                switch (type) {
                //=== Standard captcha
                case 0:
                    if (captchaCorrect) {
                        // console.log('Captcha correct');
                        resolve({ response, userPin });
                    }
                    else {
                        showErr();
                    }
                    break;
                //=== REcaptcha
                case 2:
                    if (captchaCorrect && !showRecaptcha) {
                        // console.log('Captcha correct and dont show REcaptcha');
                        resolve({ response, userPin });
                    }
                    else if (showRecaptcha && (
                        typeof (grecaptcha) === 'object' ||
                        typeof (hcaptcha) === 'object' ||
                        typeof (turnstile) === 'object'
                    )) {
                        /* HACK!
                            Reason: https: //jira.dev.inbox.lv/browse/LOGIN-2648
                            Bootstrap modal adds "top: -{content scrolled}px" to the <body>
                            Google captcha is positionend relative to the <body> so top part of the widget gets hidden
                        */
                        document.querySelector('body').style.top = 0;

                        $(cid).hide(500, function () {
                            $userPin.prop('readonly', true);
                            alertFn.show('danger', i18n.recaptchaText);
                            $(rcWrapId).show();
                        });

                        let captchaObject = null;
                        let responseFieldName = 'g-recaptcha-response';
                        if (typeof (hcaptcha) === 'object') {
                            captchaObject = hcaptcha;
                            responseFieldName = 'h-captcha-response';
                        } else if (typeof (turnstile) === 'object') {
                            captchaObject = turnstile;
                            responseFieldName = 'cf-turnstile-response';
                        } else {
                            captchaObject = grecaptcha;

                        }
                        const captchaWrapperEl = document.querySelector(rcWrapId);
                        captchaObject.render(captchaWrapperEl, {
                            'sitekey': grecaptchaSiteKey,
                            'callback': (token) => {
                                const responseField = document.querySelector('input[name="'+responseFieldName+'"]');
                                if (responseField) {
                                    responseField.value = token;
                                }
                                resolve({ response, userPin });
                            }
                        });
                    }
                    else if (!captchaCorrect && !showRecaptcha) {
                        showErr();
                    }
                }
            });
    });
}

// TODO: Refactor defaults & opts!
let Captcha2 = function (opts) {
    let me    = this,
        chtml = null;

    // Remove maxLength property. See comments in defaults section!
    delete opts.maxLength;

    opts = {... defaults, ...opts };

    const setupEventHandlers = eventHandlers(opts, me);

    this.param = {
        get(key) {
            if (key === undefined) {
                return opts;
            }
            else {
                return (Object.hasOwnProperty.call(opts, key)) ? opts[key] : false;
            }
        },
        set(...args) {
            let [key, val] = args;
            if (typeof(key) === 'string') {
                opts[key] = val;
            }
            else if (typeof(key) === 'object') {
                Object.assign(opts, key);
            }
        }
    };

    this.nameSpace = function (nsp) {
        if (typeof(nsp) === 'string' && nsp.trim().length > 0) {
            opts.nameSpace = nsp.trim();
            return opts.nameSpace;
        }
        else if (opts.nameSpace.length > 0) {
            return opts.nameSpace;
        }
        else {
            return false;
        }
    };

    this.getHtml = function () {
        const i18n = opts.i18n;
        if ($.isEmptyObject(chtml)) {
            chtml = captchaTpl({
                btnText:      i18n.btnText,
                btnTitle:     i18n.btnTitle,
                cid:          opts.cid.slice(1),
                errorClass:   '',
                inputClass:   opts.inputClass.slice(1),
                inputID:      opts.inputID.slice(1),
                inputName:    opts.inputName,
                labelText:    i18n.labelText,
                maxLength:    opts.maxLength,
                minLength:    opts.minLength,
                showHint:     opts.showHint,
                tootltipText: i18n.tooltipText
            }) + recaptchaTpl(opts.rcContainerID.slice(1));
        }
        return chtml;
    };

    this.getUrl = function (nsp) {
        var urlParams = ['?'];
        if (nsp) {
            this.nameSpace(nsp);
        }
        if (this.nameSpace()) {
            urlParams.push('namespace=' + this.nameSpace() + '&');
        }
        return opts.imgPath + urlParams.join('') + getRndHash();
    };

    this.setBgUrl = function (obj) {
        obj.css('background-image', 'url(' + this.getUrl(opts.nsp) + ')');
    };

    this.setFocus = function (clearValue = true) {
        const $inputField = $(opts.inputID, opts.cid);
        if (clearValue) {
            $inputField.val('');
        }
        $inputField.focus();
    };

    this.regenerate = function (focus) {
        // Set new captcha
        me.setBgUrl($(opts.imgName, opts.cid));
        // Focus captcha entry field
        if (focus !== 0) {
            this.setFocus();
        }
    };

    this.check = function () {
        const { callBack } = opts;

        return checkPinLength(me)
            .then((userPin) => {
                // console.log('Pin entered!');
                return userPin;
            })
            .then((userPin) => {
                // console.info('Getting server response for pin %s', userPin);
                return getResponse(me, userPin);
            })
            .then(({ response, userPin }) => {
                // console.info('Captcha response received!', response);
                if (response && typeof(response) === 'function') {
                    response();
                }
                callBack.submitForm(me, userPin);
            });
    };

    this.render = function (alertFn, htmlOnly) {
        let captchaHtml = this.getHtml();

        if (htmlOnly) {
            return captchaHtml;
        }
        if (!opts.elmWrapID) {
            throw new Error('Missing captcha wrapper id or class name!');
        }

        me.jqo = $(captchaHtml);
        $(opts.elmWrapID).prepend(me.jqo);
        me.setBgUrl($(opts.imgName, me.jqo));
        setupEventHandlers();

        if (opts.autoFocus) {
            this.setFocus();
        }
    };
};

export default (opts) => {
    if (typeof(instance) !== 'object') {
        instance = new Captcha2(opts);
    }
    return instance;
};
